<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ref="formconfiglist"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		<add :formid="formid" :row="currentrow" ref="formconfigadd" @success="addsuccess" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import add from './add/index.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			formid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '导入配置',
				modal_width:600,
				modal_height:500,
				currentrow:null
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
				gridOptions.columns = [{
						field: 'code',
						title: '编码',
					},{
						field: 'name',
						title: '名称',
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 120,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button style="color:#F56C6C" type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.formconfig.list({formid:this.formid}).then((res)=>{
						resolve(res)
					})
				})
			},
			add(){
				this.currentrow = null
				this.$refs.formconfigadd.modal_show()
			},
			edit(row){
				this.currentrow = row
				this.$refs.formconfigadd.modal_show()
			},
			del(row){
				this.$confirm('是否确认删除').then(()=>{
					this.$api.formconfig.delete(row.id).then(()=>{
						this.$refs.formconfiglist.commitProxy('query')
					})
					
				})
			},
			addsuccess(){
				this.$refs.formconfiglist.commitProxy('query')
			},
			submit() {
				
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			add	
		}
	}
</script>